function activateProductCarousel(){

    var productCarousels = document.querySelectorAll(".product-carousel-container")
    productCarousels.forEach(productCarousel => {
        var carouselContainer = productCarousel.querySelector(".carousel-container")
        var carousel = productCarousel.querySelector(".carousel-slides")
        
        if(!carouselContainer)
            return

        var prevButton = productCarousel.querySelector(".prev")
        var nextButton = productCarousel.querySelector(".next")
        var carouselSlides = carouselContainer.querySelectorAll(".carousel-slide")
        var slideWidth = carouselSlides[1].offsetWidth
        var totalWidth = carousel.scrollWidth;

        // Event listener for PREV scroll button
        prevButton.addEventListener("click", () => {
            carousel.scrollTo({ left: carousel.scrollLeft - slideWidth, behavior: 'smooth' });
            nextButton.classList.remove("inactive")
        });
        
        // Event listener for NEXT scroll button
        nextButton.addEventListener("click", () => {
            carousel.scrollTo({ left: carousel.scrollLeft + slideWidth, behavior: 'smooth' });
            prevButton.classList.remove("inactive")
        });

        carousel.addEventListener("scrollend", () => {
            const scrollPosition = carousel.scrollLeft;
        
            // Check if at the start
            if (scrollPosition <= 0) {
                // disable prev button
                prevButton.classList.add("inactive")
            }
        
            // Check if at the end
            if (scrollPosition >= totalWidth - carousel.clientWidth) {
                // disable next button
                nextButton.classList.add("inactive")
            }
        });

        
        resizeDummySlide()
        window.addEventListener("resize", () => {
            resizeDummySlide()
        });

        // This function adjusts the size of the dummy slide in a carousel so the first slide always aligns with the carousel heading.
        function resizeDummySlide(){
            var carouselHeading = productCarousel.querySelector(".carousel-heading .heading")
            var dummySlide = productCarousel.querySelector(".carousel-slide-dummy")
            if (carouselHeading){
                carousel.style.paddingLeft = 0
                var dummySlideWidth = carouselHeading.offsetLeft - 10
                dummySlide.style.width = dummySlideWidth+"px"
            }
        }

    });
}

window.addEventListener("load", function() {
    try {
        activateProductCarousel();
    } catch (error) {
        console.error("Error in activateProductCarousel:", error);
    }
});